export const readJSON = (key) => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const writeJSON = (key, value) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (value === undefined || value === null) {
      window.sessionStorage.removeItem(key);
    } else {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    }
  } catch (error) {
    // Ignore write errors for now.
  }
};
